var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4522 14.0294C16.9053 10.7388 15.2027 8.28836 13.7225 6.84909C13.2917 6.43027 13.0764 6.22086 12.6007 6.02706C12.1249 5.83325 11.716 5.83325 10.8982 5.83325H9.10183C8.28401 5.83325 7.87508 5.83325 7.39935 6.02706C6.92361 6.22086 6.70826 6.43027 6.27753 6.84909C4.79735 8.28836 3.09467 10.7388 2.54772 14.0294C2.14077 16.4778 4.39939 18.3333 6.9236 18.3333H13.0764C15.6006 18.3333 17.8592 16.4778 17.4522 14.0294Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0471 3.70247C5.87518 3.45223 5.62599 3.11257 6.14074 3.03512C6.66985 2.95551 7.21926 3.3177 7.75704 3.31026C8.24356 3.30352 8.49142 3.08774 8.75733 2.77965C9.03733 2.45522 9.47092 1.66675 9.99992 1.66675C10.5289 1.66675 10.9625 2.45522 11.2425 2.77965C11.5084 3.08774 11.7563 3.30352 12.2428 3.31026C12.7806 3.3177 13.33 2.95551 13.8591 3.03512C14.3738 3.11257 14.1247 3.45223 13.9528 3.70247L13.1753 4.83395C12.8428 5.31796 12.6766 5.55997 12.3286 5.6967C11.9807 5.83341 11.531 5.83341 10.6318 5.83341H9.36809C8.46884 5.83341 8.01917 5.83341 7.67122 5.6967C7.32327 5.55997 7.157 5.31796 6.82446 4.83395L6.0471 3.70247Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3557 10.7656C11.1755 10.1005 10.2585 9.50031 9.15775 9.94931C8.05699 10.3982 7.88214 11.8428 9.54717 11.9963C10.2997 12.0656 10.7903 11.9158 11.2395 12.3397C11.6887 12.7636 11.7722 13.9424 10.6238 14.2601C9.4755 14.5777 8.33842 14.0814 8.2146 13.3765M9.86817 9.16064V9.79431M9.86817 14.3578V14.994",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.034ba22ad189e4fd96d6a2219c126e9b.svg";
export { ForwardRef as ReactComponent };